import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-upload";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-date-time-picker";
function ConfigurationItemDiaryTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    self.ConfigurationItem = parent;
    self.Bao = Bao;
    self.CompleteCheck = function () {
        return true;
    };
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.DiaryCollection = ko.observableArray([]);
    self.ShowProjectEntries = ko.observable(false);
    self.SelectedDiaryRow = ko.observable({});
    self.SelectedDiaryRow.subscribe(function () {
        if (self.SelectedDiaryRow() == null) {
            self.enableDisableButton("EditDiary", false);
            self.enableDisableButton("DeleteDiary", false);
        }
        else {
            self.enableDisableButton("EditDiary", true);
            self.enableDisableButton("DeleteDiary", true);
        }
    });
    self.ShowProjectEntriesSubscribeFn = function () {
        self.RefreshGrid();
    };
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemDiary");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddDiary":
                self.ShowConfigurationItemDiaryDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "EditDiary":
                if (self.SelectedDiaryRow() != null) {
                    self.EditConfigurationItemDiary(self.SelectedDiaryRow());
                }
                break;
            case "DeleteDiary":
                if (self.SelectedDiaryRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteConfigurationItemDiary(self.ConfigurationItem.ConfigurationItemId(), self.SelectedDiaryRow().ConfigurationItemDiaryId);
                        }
                    });
                }
                break;
            case "ConfigurationItemDiaryTabAuditTrail":
                self.AuditTrail();
                break;
        }
    };
    self.GetFirstSelectedId = function () {
        if (ko.unwrap(self.SelectedDiaryRow()) != null) {
            return ko.unwrap(self.SelectedDiaryRow().ConfigurationItemDiaryId);
        }
        return null;
    };
    self.AuditTrail = function () {
        var auditDialog = null;
        if (self.GetFirstSelectedId() !== null) {
            auditDialog = new ConfigurationItemAuditDialog(self.GetFirstSelectedId(), ko.unwrap(tabPage.Title), tabPage, "ConfigurationItemTab/CreateAuditTrailDiary");
        }
        else {
            auditDialog = new ConfigurationItemAuditDialog(self.ConfigurationItem.ConfigurationItemId(), ko.unwrap(tabPage.Title), tabPage, "ConfigurationItemTab/CreateAuditTrailOverviewDiary", true);
        }
        auditDialog.Open();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemDiaryCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting(),
            customFilter: [{
                    Key: "ShowProjectEntries",
                    Value: ko.unwrap(self.ShowProjectEntries)
                }]
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedDiaryRow(null);
            self.TotalRows(0);
            self.DiaryCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DiaryCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddConfigurationItemDiary = function (model, configurationItemId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/AddConfigurationItemDiary", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            diaryModel: ko.map.toJS(model),
            configurationItemId: configurationItemId
        }), function () {
            self.ConfigurationItem.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.DeleteConfigurationItemDiary = function (configurationItemId, configurationItemDiaryId) {
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemDiary", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemDiaryId: configurationItemDiaryId
        }), function () {
            self.ConfigurationItem.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.EditConfigurationItemDiary = function (item) {
        self.ShowConfigurationItemDiaryDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItemDiaryId);
    };
    self.ShowConfigurationItemDiaryDialog = function (configurationItemId, configurationItemDiaryId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemDiaryDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(configurationItemId, configurationItemDiaryId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddConfigurationItemDiary(dialog.DialogViewModel, self.ConfigurationItem.ConfigurationItemId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ConfigurationItemTab/ResetConfigurationItemDiary", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function (savetime) {
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemDiaryCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: savetime
        }));
    };
    self.loaded = function () {
        return self.Refresh().then(function () {
            self.ShowProjectEntries.subscribe(self.ShowProjectEntriesSubscribeFn);
        });
    };
}
;
Bao.inherit(ConfigurationItemDiaryTabModel, ChildTabViewModel);
export default ConfigurationItemDiaryTabModel;